import { useEffect } from "react";
import { useGroups } from "../../api/hooks/groups";
import GroupCardProcess from "../../pages/Groups/components/GroupCardProcess";
import { StrToCurrency } from "../../api/ApiGame";
import { Divider, Link } from "@mui/joy";
import BetList from "../BetList";
import styles from "./index.module.css";
import { useTranslation } from "react-i18next";
import ArrowRightIcon from "../Icon/ArrowRightIcon";
import { useNavigate } from "react-router-dom";

const SideGroup = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { groups, fetchGroups } = useGroups();
  useEffect(() => {
    fetchGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fires once on mount; fetcher identity is not a trigger
  }, []);

  return (
    <div className={styles.card}>
      <div className={styles.cardTitle}>{t("groups.popular")}</div>
      {groups.slice(0, 5).map((item: any) => (
        <div
          key={item.groupId}
          className={styles.groupCard}
          onClick={() => {
            navigate(`/groups/${item.groupId}`);
          }}
        >
          <div className={styles.groupCardHeader}>
            <div className={styles.groupCardImage}>
              <img src={item.game.imgUrl} width={64} height={64} alt="" loading="lazy" decoding="async" />
            </div>
            <div className={styles.groupCardProcess}>
              <GroupCardProcess process={item.chances} />
            </div>
          </div>
          <div className={styles.groupCardName}>{item.game.gameName}</div>
          <div className={styles.groupCardInfo}>
            <div>
              <div className={styles.groupCardInfoLabel}>
                {t("groups.price")}
              </div>
              <div className={styles.groupCardInfoValue}>
                {StrToCurrency(item.groupPrice)}
              </div>
            </div>
            <div>
              <div className={styles.groupCardInfoLabel}>
                {t("groups.numbers")}
              </div>
              <div className={styles.groupCardInfoValue}>{item.peopleNum}</div>
            </div>
          </div>
          <Divider />
          <BetList betsList={item.numbers} size="xxs" defaultType="user" />
        </div>
        // <GroupsCard key={item.id} groupData={item} />
      ))}
      <div className={styles.GroupsFooter}>
        <Link href="/groups">
          {t("groups.all")}
          <ArrowRightIcon size="14px" />
        </Link>
      </div>
    </div>
  );
};

export default SideGroup;
